import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/ComingSoon.css';

function ComingSoon({ title }) {
  const navigate = useNavigate();
  
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <h1>{title || 'Coming Soon'}</h1>
        <p>This feature is currently under development and will be available soon.</p>
        <button 
          className="back-button" 
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
      </div>
    </div>
  );
}

export default ComingSoon;
